import React, {Component} from 'react';
import {observer} from 'mobx-react';
import classNames from 'classnames/bind';
import Button from "../../../../../../components/Button";
import intl from "react-intl-universal";

import './ThumbRating.css';

@observer
class ThumbRating extends Component {
    handleReactionChange = (reaction) => {
        if (reaction === this.props.appStore.pendingState.element.reaction) {
            this.props.appStore.setPendingElementReaction('none');
        } else {
            this.props.appStore.setPendingElementReaction(reaction);
        }
    };
    getReactionTitle = () => {
        return intl.get("EditModal.reactionTitle");
        //BUG in IE when it can't handle empty value
    };
    render() {
        return (
            <div className="ThumbRating">
                <label htmlFor="reaction">{this.getReactionTitle()}</label>
                <div className="reactionContainer">
                    <Button name="reaction" aria-label="Good" onClick={() => this.handleReactionChange('approve')}
                            className={classNames({
                                'active': (this.props.appStore.pendingState.element && this.props.appStore.pendingState.element.reaction === 'approve'),
                                'approve': true
                            })}>
                        <i className="fa fa-thumbs-up" aria-hidden="true"/>
                    </Button>
                    <Button name="reaction" aria-label="Bad" onClick={() => this.handleReactionChange('disapprove')}
                            className={classNames({
                                'active': (this.props.appStore.pendingState.element && this.props.appStore.pendingState.element.reaction === 'disapprove'),
                                'disapprove': true
                            })}>
                        <i className="fa fa-thumbs-down" aria-hidden="true"/>
                    </Button>
                </div>
            </div>
        );
    }
}

export default ThumbRating;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/PopupContainer/components/ThumbRating/index.js